import { Link } from "react-router-dom";

import "./css/not-found.css";

const NotFound = ({ whatNotFound }) => {
    return (
        <div className="not-found">
            <div>
                <span
                    className="title b-title"
                    style={{ color: "#000" }}
                >
                    404 | {whatNotFound} Not Found
                </span>

                {(whatNotFound === "Doubt" || whatNotFound === "User") &&
                    <span className="not-found-action">
                        Return to&nbsp;
                        <Link className="not-found-action-link" to="/">
                            Home
                        </Link>
                    </span>
                }
            </div>
        </div>
    );
}

export default NotFound;